/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { Side } from "../Side";
import { FaceConfigurationSectionFragmentCombinationDefinitionDto } from "./FaceConfigurationSectionFragmentCombinationDefinitionDto";
import { AreaFragmentDto } from "./Sections/AreaFragmentDto";

export class FaceConfigurationSectionFragmentCombinationDto {
    id: string | null;
    name: string;
    side: Side;
    faceConfigurationId: string;
    configurationTemplateId: string;
    organisationId: string;
    minWidth: number;
    maxWidth: number;
    faceConfigurationSectionFragmentCombinationDefinitions: FaceConfigurationSectionFragmentCombinationDefinitionDto[];
    areaFragments: AreaFragmentDto[];
}
